require([
    "ulysses/core",
    "jquery",
    "globalize",
    "knockout",
    "ulysses/preferences",
    "ulysses/login.html",
    "ulysses/api",
    "sha",
    "md5",
    "wysihtml5",
    "moment",
    "leaflet",
    "markercluster",
    "cilogi-marker",
    "URI/URITemplate",
    "URI/URI",
    "pubsub",
    "jquery/jquery.mousewheel",
    "gritter",
    "jquery/jquery.validate",
    "jquery/jquery.validate.methods",
    "jquery/icheck",
    "sticky-kit",
    "jquery/fullcalendar",
    "jquery/jquery.trap",
    "datatables",
    "datatables-responsive",
    "datatables-scroller",
    "datatables-colreorder",
    //datatables boostrap has to be the last one
    "datatables.net",
    "ko.mapping-latest",
    "ko.observableDictionary",
    "jquery-ui",
    "jqueryui/jquery.ui.touch-punch",
    "jqueryui/jquery-ui-timepicker-addon",
    "bootstrap",
    "bootstrap/bootstrap3-wysihtml5",
    "bootstrap/bootstrap-select",
    "bootstrap/jquery.validate.bootstrap.popover",
    
    //"fileupload/jquery.iframe-transport",
    //"fileupload/jquery.fileupload",
    //"fileupload/jquery.fileupload-process",
    //"fileupload/jquery.fileupload-validate",
    //"fileupload/jquery.fileupload-ui",
    //"lucene_query_parser.js",
    "marked",
    "iscroll",
    //uh? "/static/js/mylibs/md5-min.js",
    "socketio",
    "d3/d3",
    "d3/nv.d3",
    "d3/topojson",
    
    // "adminlte/app",
    "ulysses/widgets",
    "ulysses/core_widgets",
    "ulysses/core_controls",
    "ulysses/components/menu",
    "e-query",
    "ulysses/app"
], function(uly, $, Globalize, ko, prefs, login_template, HalResource) {
    console.log("All loaded and ready to go!");
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/index.js
 ** module id = 138
 ** module chunks = 0
 **/